module.exports = __webpack_public_path__ + "static/media/icon-term.1ebdb274.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-term.svg
// module id = 547
// module chunks = 0